import * as React from "react";
import Router from "./router";
import "./App.css";
import Backgroundimage from "./assets/Login Page Background.png";

// 👉 import MUI theme helpers
import { createTheme, ThemeProvider } from "@mui/material/styles";

// 👉 define your custom theme
const theme = createTheme({
  components: {
    MuiTextField: {
      defaultProps: {
        size: "small",
        fullWidth: true,

      },
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            height: 40,
             maxWidth: "300px",
          
           
          },
          "& .MuiInputBase-input": {
            padding: "8px 12px",
          },
        },
      },
    },
  },
});

function App() {
  return (
    // 👉 wrap your whole app in ThemeProvider
    <ThemeProvider theme={theme}>
      <div className="App">
        <Router />
      </div>
    </ThemeProvider>
  );
}

export default App;
